module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Black.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Black.woff
// module id = 66
// module chunks = 8